import type { QuotationDocumentData } from '@/pages/quotation-design/types';
import SectionTitle from './SectionTitle';

export default function Authorization({ data }: { data: QuotationDocumentData }) {
  const auth = data.authorization;
  if (!auth) return null;

  return (
    <div className="px-6 md:px-9 mt-8">
      <SectionTitle>Authorized By</SectionTitle>
      <div className="mt-4 flex items-end justify-between gap-6">
        <div>
          <p className="text-sm font-bold text-ink-700">{auth.name}</p>
          <p className="text-xs text-ink-500 mt-0.5">{auth.position}</p>
          <p className="text-xs text-ink-400 mt-0.5">{auth.company}</p>
        </div>
        <div className="text-right">
          <p className="text-xs text-ink-400">Issued Date</p>
          <p className="text-sm font-medium text-ink-700 mt-0.5">{auth.issuedDate}</p>
        </div>
      </div>
    </div>
  );
}